import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../../actions/reportAction';
import * as orderAction from './../../../../../../actions/orderAction';
import OrderDetailReportsBySKU from './OrderDetailReportsBySKU';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSaleDetailReportBySKU: (filters) => dispatch(reportAction.getSaleDetailReportBySKU(filters)),
        exportSkuSaleDetailExcel: filters => dispatch(orderAction.exportSkuSaleDetailExcel(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderDetailReportsBySKU));
